var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c("div", { staticClass: "mb10" }, [
        _c("span", [
          _vm._v("预计合同总金额: "),
          _vm.contract.estmtAmount != null
            ? _c("span", [
                _vm._v(_vm._s(_vm.contract.estmtAmount.toFixed(2)) + " 元")
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.contractType != _vm.servcPurch.value
          ? _c("span", { staticClass: "ml20" }, [
              _vm._v("预计合同商品数量: "),
              _c("span", [_vm._v(_vm._s(_vm.contract.estmtGoodsCount))])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "custom-tbl" }, [
        _c("thead", { staticClass: "head" }, [
          _c("tr", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("th", { attrs: { width: "100" } }, [_vm._v("预计金额(元)")]),
            _vm._v(" "),
            _c("th", { attrs: { width: "100" } }, [_vm._v("实际金额(元)")]),
            _vm._v(" "),
            _c("th", { attrs: { width: "100" } }, [_vm._v("预计金额(%)")]),
            _vm._v(" "),
            _c("th", { attrs: { width: "100" } }, [_vm._v("实际金额(%)")]),
            _vm._v(" "),
            _vm.contractType != _vm.servcPurch.value
              ? _c("th", { attrs: { width: "80" } }, [_vm._v("预计数量")])
              : _vm._e(),
            _vm._v(" "),
            _vm.contractType != _vm.servcPurch.value
              ? _c("th", { attrs: { width: "80" } }, [_vm._v("实际数量")])
              : _vm._e(),
            _vm._v(" "),
            _vm.contractType != _vm.servcPurch.value
              ? _c("th", { attrs: { width: "90" } }, [_vm._v("预计数量(%)")])
              : _vm._e(),
            _vm._v(" "),
            _vm.contractType != _vm.servcPurch.value
              ? _c("th", { attrs: { width: "90" } }, [_vm._v("实际数量(%)")])
              : _vm._e(),
            _vm._v(" "),
            _c("th", { attrs: { width: "100" } }, [_vm._v("付款账期(天)")]),
            _vm._v(" "),
            _c("th", { attrs: { width: "100" } }, [_vm._v("账期开始")]),
            _vm._v(" "),
            _c("th", { attrs: { width: "100" } }, [_vm._v("账期结束")]),
            _vm._v(" "),
            _c("th", { attrs: { width: "100" } }, [_vm._v("质保开始日")]),
            _vm._v(" "),
            _c("th", { attrs: { width: "80" } }, [_vm._v("当前阶段")]),
            _vm._v(" "),
            _c("th", { attrs: { width: "100" } }, [_vm._v("操作")])
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          { staticClass: "body" },
          _vm._l(_vm.contractTrackPhaseList, function(trackPhase, index) {
            return _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "align-left" }, [
                _c("span", { staticClass: "pl5" }, [
                  _vm._v(_vm._s(trackPhase.name))
                ])
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(trackPhase.amountPay.toFixed(2)))]),
              _vm._v(" "),
              _c("td", { staticClass: "font-green" }, [
                trackPhase.reatilyAmount != null
                  ? _c("span", [
                      _vm._v(_vm._s(trackPhase.reatilyAmount.toFixed(2)))
                    ])
                  : _c("span", [_vm._v("0.00")])
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(trackPhase.amountPayPct.toFixed(2)))]),
              _vm._v(" "),
              _c("td", { staticClass: "font-green" }, [
                trackPhase.estmtAmount != null && trackPhase.estmtAmount != 0
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          (
                            (trackPhase.reatilyAmount /
                              trackPhase.estmtAmount) *
                            100
                          ).toFixed(2)
                        )
                      )
                    ])
                  : _c("span", [_vm._v("0.00 %")])
              ]),
              _vm._v(" "),
              _vm.contractType != _vm.servcPurch.value
                ? _c("td", [_vm._v(_vm._s(trackPhase.goodsDeliverCount))])
                : _vm._e(),
              _vm._v(" "),
              _vm.contractType != _vm.servcPurch.value
                ? _c("td", { staticClass: "font-green" }, [
                    _vm._v(_vm._s(trackPhase.reatilyQuantity))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.contractType != _vm.servcPurch.value
                ? _c("td", [
                    trackPhase.goodsDeliverCountPct != null
                      ? _c("span", [
                          _vm._v(
                            _vm._s(trackPhase.goodsDeliverCountPct.toFixed(2))
                          )
                        ])
                      : _c("span", [_vm._v("0.00")])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.contractType != _vm.servcPurch.value
                ? _c("td", { staticClass: "font-green" }, [
                    trackPhase.estmtGoodsCount != null &&
                    trackPhase.estmtGoodsCount != 0
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              (
                                (trackPhase.reatilyQuantity /
                                  trackPhase.estmtGoodsCount) *
                                100
                              ).toFixed(2)
                            )
                          )
                        ])
                      : _c("span", [_vm._v("0.00 %")])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(trackPhase.payDays))]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    trackPhase.payStartTime == null
                      ? null
                      : _vm.formatDate(trackPhase.payStartTime)
                  )
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    trackPhase.payDueTime == null
                      ? null
                      : _vm.formatDate(trackPhase.payDueTime)
                  )
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    trackPhase.wrntPeriodStartTime == null
                      ? null
                      : _vm.formatDate(trackPhase.wrntPeriodStartTime)
                  )
                )
              ]),
              _vm._v(" "),
              _c("td", [
                trackPhase.wrntPeriodStarted
                  ? _c("span", { staticClass: "font-green" }, [
                      _vm._v("质保已起算")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !trackPhase.wrntPeriodStarted && trackPhase.deliverFinished
                  ? _c("span", { staticClass: "font-green" }, [
                      _vm._v("交付完成")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                trackPhase.active ? _c("span", [_vm._v("是")]) : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                trackPhase.active
                  ? _c(
                      "a",
                      {
                        staticClass: "swb-btn-link ml10",
                        on: {
                          click: function($event) {
                            _vm.endContractTrackPhase(trackPhase)
                          }
                        }
                      },
                      [_vm._v("交付完成")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                trackPhase.deliverFinished && !trackPhase.wrntPeriodStarted
                  ? _c(
                      "a",
                      {
                        staticClass: "swb-btn-link ml10",
                        on: {
                          click: function($event) {
                            _vm.doStartWrntPeriod(trackPhase)
                          }
                        }
                      },
                      [_vm._v("起算质保")]
                    )
                  : _vm._e()
              ])
            ])
          })
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", { staticClass: "align-left" }, [
      _c("span", { staticClass: "pl5" }, [_vm._v("阶段名称")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c63583c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c63583c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ContractDataMonitoring.vue
// module id = 2746
// module chunks = 0